import {
  buildUrl,
  getForumLink,
  getGroupForumLink,
  getWeekDiscussionsUrl,
} from 'bundles/discussions/utils/discussionsUrl';

import type { ForumPostSearchResult } from '../__types__';

const getThreadUrl = (post: ForumPostSearchResult) => {
  const { forumPost, forumInfo } = post;
  const forumType = forumInfo?.forumType;
  const forumId = forumInfo?.forumId;
  const forumGroupId = forumInfo?.forumScope?.courseGroupForumScope?.groupId;
  const threadId = forumPost.topLevelPostId;

  if (!forumType || !forumId) return undefined;
  if ('courseBranchWeekForumType' in forumType) {
    return buildUrl(getWeekDiscussionsUrl(forumType.courseBranchWeekForumType.weekNumber), threadId);
  } else if ('courseGroupRootForumType' in forumType) {
    return buildUrl(getGroupForumLink(forumGroupId), threadId);
  } else {
    return buildUrl(getForumLink(forumId), threadId);
  }
};

export default getThreadUrl;
